










import Vue from 'vue'
import PersonalDataForm from '@/UI/AuctionB/PersonalData/PersonalDataForm.vue'
import RepresentationForm from '@/UI/AuctionB/PersonalData/RepresentationForm.vue'

export default Vue.extend({
  name: 'PersonalData',
  components: {
    PersonalDataForm,
    RepresentationForm
  }
})
